import React from 'react';
import { IconButton } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';

import CopyToClipboard from 'components/shared/CopyToClipboard';

interface CopyMessageProps {
  text?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'inline-flex',
    position: 'absolute',
    right: theme.spacing(-8),
    top: 0,
    bottom: 0,
    color: theme.palette.grey[500],
    fontSize: theme.spacing(1.5),
    fontWeight: 500,
    '& svg': {
      display: 'inline-flex',
      width: theme.spacing(1.5),
      fill: theme.palette.grey[500],
      margin: theme.spacing(0, 0.25),
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

const CopyMessage = ({ text }: CopyMessageProps) => {
  const classes = useStyles({ text });

  return (
    <CopyToClipboard text={text}>
      <IconButton className={classes.root}>
        copy <FileCopyOutlinedIcon />
      </IconButton>
    </CopyToClipboard>
  );
};

export default CopyMessage;
